<div class="swatch">
    <ng-content></ng-content>
    <div class="colour"
         [style.background-color]="value">
        <p [style.color]="textColorValue">
            {{ rgb }}<br />
            {{ hex }}<br />
            <ng-content select="[swatch-inner-content]"></ng-content>
        </p>
        @if (colorVariants; as colorVariantsList) {
            <div class="sub-colour">
                @for (variant of colorVariantsList; track variant) {
                    <div class="colour"
                         style="background-color: {{ variant.value }}">
                        <div class="percentage">
                            {{ variant.name }}
                            @if (isPercentage) {
                                <span>%</span>
                            }
                        </div>
                    </div>
                }
            </div>
        }
    </div>
    <div class="variable">
        {{ getCssVariableDisplay(variable) }}
        @if (colorVariants; as colorVariantsList) {
            <span class="small">
                @for (variant of colorVariantsList; track variant) {
                    <br />{{ getCssVariableDisplay(variable + "-" + variant.name) }}
                }
            </span>
        }
    </div>
</div>
